import React from "react";
import { OrgData, UserData } from "./types";
import { Permission } from "./types/Permissions";

interface IUserContext {
  user?: UserData;
}

export const UserContext = React.createContext<IUserContext>({});

interface IOrgContext {
  org?: OrgData;
  setOrg: (org: OrgData) => void;
}

export const OrgContext = React.createContext<IOrgContext>({
  setOrg: () => {
    throw new Error("OrgContext not initialized");
  },
});
export const ORGANIZATION_KEY = "organization_data";

interface IPermissionsContext {
  permissions: Permission[];
}

export const PermissionsContext = React.createContext<IPermissionsContext>({
  permissions: [],
});
